const Palette = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4001 2.09605C11.7512 1.87036 10.0721 2.05644 8.51269 2.63767C6.95325 3.21891 5.56199 4.17721 4.46308 5.42705C3.52258 6.51023 2.82476 7.78213 2.4165 9.15732C2.00824 10.5325 1.89899 11.9791 2.09608 13.4C2.62608 17.294 5.55408 20.607 9.38108 21.646C10.2342 21.8795 11.1146 21.9986 11.9991 22L12.1411 21.999C12.6466 21.9925 13.1423 21.8584 13.5822 21.6091C14.022 21.3598 14.3918 21.0034 14.6571 20.573C14.9233 20.145 15.0769 19.6566 15.1036 19.1532C15.1304 18.6499 15.0294 18.1479 14.8101 17.694L14.6111 17.278C14.458 16.979 14.3861 16.645 14.4026 16.3095C14.4191 15.974 14.5234 15.6486 14.7051 15.366C14.965 14.9438 15.3722 14.633 15.848 14.4935C16.3238 14.3541 16.8344 14.3959 17.2811 14.611L17.6931 14.808C18.1051 15.006 18.5431 15.107 18.9941 15.107C19.7834 15.103 20.5397 14.7903 21.1015 14.2359C21.6632 13.6814 21.9857 12.9292 22.0001 12.14C22.0125 11.208 21.8936 10.2789 21.6471 9.38005C20.6071 5.55405 17.2941 2.62605 13.4001 2.09605ZM18.5581 13.005L18.1461 12.808C16.3181 11.93 14.0761 12.61 13.0111 14.302C12.2731 15.478 12.1981 16.878 12.8071 18.144L13.0061 18.56C13.0807 18.7112 13.1152 18.8789 13.1062 19.0472C13.0973 19.2155 13.0452 19.3787 12.9551 19.521C12.8672 19.6665 12.7434 19.7869 12.5957 19.8708C12.4479 19.9547 12.281 19.9992 12.1111 20H11.9991C11.2914 19.9981 10.587 19.9029 9.90408 19.717C6.84108 18.886 4.50108 16.238 4.07808 13.131C3.75708 10.776 4.43008 8.50805 5.97108 6.74205C6.84782 5.73628 7.96213 4.9657 9.21264 4.50043C10.4631 4.03515 11.8101 3.88996 13.1311 4.07805C16.2381 4.50105 18.8861 6.84205 19.7171 9.90405C19.9151 10.634 20.0101 11.378 19.9991 12.111C19.9871 12.918 19.1541 13.294 18.5581 13.005Z"
        fill={color}
      />
      <path
        d="M7.5 16C8.32843 16 9 15.3284 9 14.5C9 13.6716 8.32843 13 7.5 13C6.67157 13 6 13.6716 6 14.5C6 15.3284 6.67157 16 7.5 16Z"
        fill={color}
      />
      <path
        d="M7.5 12C8.32843 12 9 11.3284 9 10.5C9 9.67157 8.32843 9 7.5 9C6.67157 9 6 9.67157 6 10.5C6 11.3284 6.67157 12 7.5 12Z"
        fill={color}
      />
      <path
        d="M10.5 9C11.3284 9 12 8.32843 12 7.5C12 6.67157 11.3284 6 10.5 6C9.67157 6 9 6.67157 9 7.5C9 8.32843 9.67157 9 10.5 9Z"
        fill={color}
      />
      <path
        d="M14.5 9C15.3284 9 16 8.32843 16 7.5C16 6.67157 15.3284 6 14.5 6C13.6716 6 13 6.67157 13 7.5C13 8.32843 13.6716 9 14.5 9Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Palette;
